import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { DynamicFormComponent } from 'app/core';
import { GroupQuestion } from '../models/group-question';
import { TutorizationQuestionService } from '../services/tutorization-question.service';
import { ChoicesService } from '../services/choices.service';

@Component({
  selector: 'lms-group-question-editor',
  templateUrl: './group-question-editor.component.html',
  styleUrls: ['./group-question-editor.component.scss']
})
export class GroupQuestionEditorComponent implements OnInit {
  @Input() question: GroupQuestion;
  @Input() groupId: string;
  @Output() onSave = new EventEmitter<GroupQuestion>();
  @ViewChild(DynamicFormComponent, { static: false }) public dynamicForm: DynamicFormComponent;
  public questions: any[];

  constructor(public questionsService: TutorizationQuestionService, public choices: ChoicesService) {}

  ngOnInit() {
    this.questions = this.choices.getQuestions(this.question, this.groupId || this.question.groupId);
  }

  submit(formData: any) {
    const questionData = this.parseFormData(formData);
    if (this.question) {
      this.onUpdate(questionData);
    } else {
      this.onCreate(questionData);
    }
  }

  parseFormData(formData) {
    const { groupId, question, status = this.question.status, _choices, _correctChoice } = formData;
    const choices = Object.keys(_choices).map((choice, index) => ({
      key: index + 1,
      text: _choices[choice],
      isCorrect: `${index + 1}` === _correctChoice
    }));
    return { groupId, question, status, choices };
  }

  onCreate(questionData: any) {
    this.questionsService
      .create(questionData)
      .then((newQuestion) => {
        this.onSave.emit(newQuestion);
        this.endSubmit(null);
      })
      .catch((err) => {
        console.error('Error:', err);
        this.endSubmit(err);
      });
  }

  onUpdate(updatedData: Object) {
    const updatedquestion: GroupQuestion = Object.assign({}, this.question, updatedData);
    this.questionsService
      .update(updatedquestion)
      .then(() => {
        this.onSave.emit(updatedquestion);
        this.endSubmit(null);
      })
      .catch((err) => {
        this.endSubmit(err);
      });
  }

  endSubmit(value) {
    this.dynamicForm.submitted(value);
  }
}
